<div class="rbac-table-wrap">
  <table class="rbac-table">
    <thead>
      <tr>
        <th *ngFor="let col of columns" [style.width]="col.width">{{ col.label }}</th>
        <th *ngIf="showActions" class="rbac-table__actions-col">Actions</th>
        <th *ngIf="showPermission" class="rbac-table__actions-col">Permission</th>
      </tr>
    </thead>
    <tbody>
<tr
        *ngFor="let row of rows; trackBy: trackByRow"
        class="rbac-table__row"
        [class.rbac-table__row--selected]="selectedRowId && row['id'] === selectedRowId"
        [class.rbac-table__row--blocked]="isRowBlocked(row)"
        (click)="onRowClick(row)">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.type">
            <span
              *ngSwitchCase="'badge-yn'"
              class="rbac-badge"
              [class.rbac-badge--on]="row[col.key] === 'Y'">
              {{ row[col.key] === 'Y' ? 'Yes' : 'No' }}
            </span>

            <span
              *ngSwitchCase="'status'"
              class="rbac-badge"
              [class.rbac-badge--on]="row[col.key] !== 'N'">
              {{ row[col.key] === 'N' ? 'Inactive' : 'Active' }}
            </span>

            <span *ngSwitchDefault>{{ getCellValue(row, col) }}</span>
          </ng-container>
        </td>

        <td *ngIf="showActions" class="rbac-table__actions-col">
          <div class="rbac-table__actions">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              title="Edit"
              (click)="$event.stopPropagation(); edit.emit(row)">
              Edit
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              title="Delete"
              (click)="$event.stopPropagation(); delete.emit(row)">
              Delete
            </button>
          </div>
        </td>
        <td *ngIf="showPermission">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            title="Manage Permissions"
            (click)="$event.stopPropagation(); permission.emit(row)">
             &#8594;
          </button>
        </td>

      </tr>

      <tr *ngIf="!loading && rows.length === 0">
        <td
          [attr.colspan]="columns.length
                          + (showActions ? 1 : 0)
                          + (showPermission ? 1 : 0)"
          class="rbac-table__empty">
          {{ emptyMessage }}
        </td>
      </tr>

      <tr *ngIf="loading">
        <td
          [attr.colspan]="columns.length
                          + (showActions ? 1 : 0)
                          + (showPermission ? 1 : 0)"
          class="rbac-table__empty">
          Loading…
        </td>
      </tr>
    </tbody>
  </table>
</div>
